import './Button.scss';

const Button = () => {
  return (
    <button type="submit" className="button">
      Оформить заказ!
    </button>
  );
};

export default Button;
